import { Skeleton } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";

const HexInfiniteScroll = ({
  data,
  children,
  onScroll,
  hasMore,
  height,
  loading,
  className = "",
  maxHeight,
  key,
}) => {
  return (
    <div
      id="scrollableDiv"
      style={{
        height: height || 590,
        overflow: "auto",
        ...(maxHeight && { maxHeight }),
      }}
      className={className}
      key={key}
    >
      <InfiniteScroll
        dataLength={data.length}
        next={onScroll}
        hasMore={hasMore}
        scrollableTarget="scrollableDiv"
        loader={loading && <Skeleton paragraph={{ rows: 1 }} active />}
      >
        {children}
      </InfiniteScroll>
    </div>
  );
};

export default HexInfiniteScroll;
